export const userConstants = {
  LOGIN_SUCCESS: "USERS_LOGIN_SUCCESS",
  LOGIN_FAILURE: "USERS_LOGIN_FAILURE",
  LOGOUT: "USERS_LOGOUT",
  UPDATE_USER: "UPDATE_USER",
  UPDATE_LANG: "UPDATE_LANG",
  UPDATE_WALLET: "UPDATE_WALLET",
  UPDATE_PERMISSIONS: "UPDATE_PERMISSIONS",
};

export const EXCLUDED_PERMISSION_NAMES = [
  "MATGAME_AVIATOR_CASINO_SLOTS_ACCESS",
  "MATGAME_DREAMTECH_CASINO_SLOTS_ACCESS",
  "MATGAME_WOWGAMING_CASINO_SLOTS_ACCESS",
  "INNOVA_PLATINGAMING_CASINO_SLOTS_ACCESS",
  "MATGAME_SAGAMING_LIVE_CASINO_ACCESS",
  "INNOVA_EVOLUTIONGHLS_LIVE_CASINO_ACCESS",
  "INNOVA_EVOLUTIONGHHS_LIVE_CASINO_ACCESS",
  "INNOVA_EVOLUTIONGHY_LIVE_CASINO_ACCESS",
  "INNOVA_PRAGMATIC-BJ2_LIVE_CASINO_ACCESS",
  "INNOVA_PRAGMATIC-BJ_LIVE_CASINO_ACCESS",
  "INNOVA_EVOLUTIONGH_LIVE_CASINO_ACCESS",
  "INNOVA_EZUGIX_LIVE_CASINO_ACCESS",
  "INNOVA_EZUGIZ_LIVE_CASINO_ACCESS",
  "INNOVA_ABSOLUTE_LIVE_CASINO_ACCESS",
  "INNOVA_EVOLUTIONGHVHS_LIVE_CASINO_ACCESS",
  "INNOVA_CREEDROOMZP_LIVE_CASINO_ACCESS",
  "INNOVA_FTVP_LIVE_CASINO_ACCESS",
  "INNOVA_EVOLUTIONGHX_GAMES_ACCESS",
  "INNOVA_EVOLUTIONGH_GAMES_ACCESS",
  "INNOVA_EZUGIZ_GAMES_ACCESS",
  "INNOVA_PRAGMATIC-LIVE_GAMES_ACCESS",
  "INNOVA_AVIATOR_GAMES_ACCESS",
  "INNOVA_CREEDROOMZ_GAMES_ACCESS",
  "INNOVA_CREEDROOMZP_GAMES_ACCESS",
  "INNOVA_EZUGI_GAMES_ACCESS",
  "INNOVA_SAGAMING_GAMES_ACCESS",
  "INNOVA_EVOLUTIONGHY_TVGAMES_ACCESS",
  "INNOVA_EVOLUTIONGH_TVGAMES_ACCESS",
];
